var CalcGold = {
	file: "zlato.json",
	path: '/templates/src/components/kalkulacky/calcGold/',
	data:{},
	select:{},
	button:{},
	debug: true,
	actualPrice:0,
	
	init: function(){
		this.el = $('[component="calc"][for="gold"]');
		if (!this.el.length) return;
		this.initSelects(this.el);
		this.load();
	},

	initSelects: function(calc){
		calc.find("select.chosen.search").chosen({
			"disable_search": false,
			no_results_text: "Nenašla sa zhoda: ",
			allow_single_deselect: true,
			search_contains: true,
			width: "100%"
		});
	},

	load: function(){
		$.getJSON( this.path + this.file, function( data ) {
			CalcGold.data = data;
			CalcGold.prepare();
		});
	},

	prepare: function(){
		this.select = this.el.find('select#birthYear');

		for (var i = 1960; i <= 2018; i++){
			$('<option/>')
				.attr('value', i)
				.text(i)
				.appendTo(this.select)
		}

		this.select.trigger("chosen:updated");

		this.bind();
	},

	bind: function(){

		this.button = this.el.find('.button.calc')
			.unbind('click')
			.click(function(event) {
				event.preventDefault();
				CalcGold.calc();
			});

		this.close = this.el.find('.button.close')
			.unbind('click')
			.click(function(event) {
				event.preventDefault();
				CalcGold.hide();
			});

		if(!$('[component="directory"]').length) return;

	},

	calc: function(){
		if (!this.select.val()) {
			this.error();
			return;
		}

		if(CalcGold.debug){
			console.log('------- calc starts -------')
			console.log('from: ', this.select.val());
		}

		var sum = 0;
		var items = 0;

		$.each(this.data, function(year, val) {
			 if(year >= CalcGold.select.val()){
			 	CalcGold.actualPrice = val;
			 	sum += parseFloat(val);
			 	items ++;

			 	if(CalcGold.debug){
			 		console.log('year: ',year, 'value: ',val)
			 	}
			 }
		});

		var usd = (CalcGold.actualPrice * items).toFixed(3);
		var profit = (usd - sum).toFixed(2);;
		var yeld = (usd / sum * 100).toFixed(2);

		if(CalcGold.debug){
			console.log('------- calc end -------');
			console.log('you paid: ', sum, ' USD');
			console.log('you own: ', items, ' ounce of gold');
			console.log('with actual price: ', CalcGold.actualPrice, ' per ounce');
			console.log('you have: ',  usd, 'USD');
			console.log('-------------------------')
			console.log('Gross profit is:', profit, 'USD');
			console.log('With yeld:',  yeld, '%');
		}

		this.result(profit, yeld);
	},

	result: function(profit, yeld){
		var result = this.el.find('.data').addClass('show').attr('load', '');

		setTimeout(function(){
			result.removeAttr('load');
			result.find('.profit').text(accounting.formatMoney(profit,"",2));
			result.find('.yeld').text(accounting.formatMoney(yeld,"",2));
		}, 500);

	},

	hide: function(){
		this.el.find('.data').removeClass('show');
	},

	error: function(){
		var chosen = this.el.find('.chosen-single').addClass('error');
		setTimeout(function(){
			chosen.removeClass('error')
		}, 2000)
	}

}